import React from 'react'
import { CheckoutPage } from '../../model'

// Generic profile created page that gets shown after a customer has verified their mobile number
// And created a consumer account in Core
// No IDV checks have been performed at this stage.
export const ProfileCreatedPage: CheckoutPage = () => {
  return <p>Profile Created</p>
}
